import { render, staticRenderFns } from "./InputRadioButton.vue?vue&type=template&id=f000feb6&"
import script from "./InputRadioButton.vue?vue&type=script&lang=js&"
export * from "./InputRadioButton.vue?vue&type=script&lang=js&"
import style0 from "./InputRadioButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports